import { render, staticRenderFns } from "./AbsencesEditorStartEnd.vue?vue&type=template&id=05dbd2e6&scoped=true&lang=pug&"
import script from "./AbsencesEditorStartEnd.vue?vue&type=script&lang=ts&"
export * from "./AbsencesEditorStartEnd.vue?vue&type=script&lang=ts&"
import style0 from "./AbsencesEditorStartEnd.vue?vue&type=style&index=0&id=05dbd2e6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dbd2e6",
  null
  
)

export default component.exports